import classNames from 'classnames';
import React from 'react';

import styles from './PlayMarker.module.scss';

const PlayMarker = () => (
  <svg
    className={classNames(styles.playMarker, 'quiver-play-marker')}
    data-testid="play-marker"
    preserveAspectRatio="xMinYMin"
    viewBox="0 0 40 40"
  >
    <g>
      <circle cx="20" cy="20" r="20" />
      <polygon points="17.5 15, 25 20, 17.5 25" />
    </g>
  </svg>
);

export default PlayMarker;
